<template lang="pug">
  label.checkbox-input(:class="{'checkbox-input--toggle' : toggle}")
    input.checkbox-input__input(
      type="checkbox",
      :value="value || label",
      v-model="isChecked"
      :disabled="disabled",
      :name="name",
      :id="inputId"
      @change="onChange"
    )
    span.checkbox-input__checkbox
      svg(
        v-if="!toggle" 
        viewBox="0 0 16 14" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="currentColor"
      )
        path(
          d="M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z" 
          fill="currentColor"
        )
    .checkbox-input__label-text(v-if="label") {{ label }}
    .checkbox-input__label-text(v-else)
      slot
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'CheckboxInput',
    components: {
      Icon,
    },
    props: {
      value: String,
      label: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      name: String,
      id: String,
      checked: Boolean,
      toggle: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isChecked: this.checked,
      };
    },
    computed: {
      inputId() {
        return this.id || `checkbox_${this._uid}`;
      },
    },
    methods: {
      onChange() {
        this.$emit('input', this.isChecked);
      }
    },
    watch: {
      checked(newChecked) {
        this.isChecked = newChecked;
      },
    },
  };
</script>
